import styled from 'styled-components';
import { getUrlWithToken } from '../../../../utils/common';

export const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column-reverse;

  @media ${(props) => props.theme.device.mobileL} {
    flex-direction: column;
  }

  .upload-box {
    border-radius: 8px;
    background: ${(props) => props.theme.colors.bgBox};
    padding: 20px 24px;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
`;

export const ResultsWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr 640px;
  gap: 24px;
  margin-bottom: 42px;
  max-height: 410px;

  .img-list {
    overflow-y: auto;
    max-height: inherit;
    position: relative;
    padding-right: 20px;
    border-right: 1px solid ${(props) => props.theme.colors.border};

    &::-webkit-scrollbar {
      width: 13px;
    }
    &::-webkit-scrollbar-thumb {
      border-right: 8px white solid;
      background-clip: padding-box;
    }
  }

  .img-box {
    border-radius: 8px;
    background: ${(props) => props.theme.colors.bgBox};
    padding: 16px 24px calc(16px + 56.25%);
    position: relative;
  }

  @media ${(props) => props.theme.device.tabletL} {
    display: block;
    max-height: unset;
    overflow-y: hidden;
    margin-bottom: 22px;

    .img-list {
      padding-right: unset;
      border-right: none;
    }
  }
`;

export const CardWrapper = styled.div`
  padding: 8px 0;
  border-bottom: 1px solid ${(props) => props.theme.colors.border};
`;

export const ImgCard = styled.div`
  display: flex;
  align-items: center;
  gap: 24px;
  padding: 8px 16px;

  &.active {
    border-radius: 4px;
    background-color: ${(props) => props.theme.colors.bgBox};
  }

  @media ${(props) => props.theme.device.tabletL} {
    align-items: flex-start;
  }
`;

export const Thumbnail = styled.div.withConfig({
  shouldForwardProp: (prop) => !['url'].includes(prop),
})`
  width: 32px;
  height: 24px;
  background-image: url(${({ url }) => getUrlWithToken(url)});
  background-position: center center;
  background-size: cover;

  @media ${(props) => props.theme.device.tabletL} {
    min-width: 150px;
    height: 108px;
    padding: 8px;
  }
`;

export const Image = styled.div.withConfig({
  shouldForwardProp: (prop) => !['url'].includes(prop),
})`
  width: calc(100% - 48px);
  overflow: hidden;
  padding-bottom: 56.25%;
  background-image: url(${({ url }) => getUrlWithToken(url)});
  background-position: center center;
  background-size: cover;
  position: absolute;
  border-radius: 4px;
  box-shadow: 0px 4px 20px 0px rgba(104, 104, 104, 0.1);
`;

export const PaginationWrapper = styled.div`
  position: sticky;
  bottom: 0;
  margin: auto;
  background-color: ${(props) => props.theme.colors.white};
  padding-top: 16px;
`;
